<nav>
  <ul class="header-navigation-list">
    <li
      *ngFor="let tab of tabs; trackBy: trackById"
      class="header-navigation-item"
    >
      <button
        class="filter-tab-btn"
        [class.active]="tab.id === activeTab"
        (click)="select(tab.id)"
      >
        <span>{{ tab.label }}</span>
        <span *ngIf="tab.count !== undefined" class="filter-tab-count">{{
          tab.count
        }}</span>
      </button>
    </li>
  </ul>
</nav>
